import React from "react";
import { motion } from "framer-motion";
import RichText from "@/components/RichText";

/**
 * A quiet, single-column reflection card. Fully driven from the CMS —
 * if body is blank, nothing renders.
 */
export default function WeeklyReflection({ eyebrow, body, attribution, testId = "home-weekly-reflection" }) {
  if (!body || (typeof body === "string" && body.trim() === "")) return null;
  return (
    <section
      className="relative overflow-hidden bg-brand-cream border-y border-brand-rule/50"
      data-testid={testId}
    >
      <div className="container-narrow py-20 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl mx-auto text-center"
        >
          {eyebrow && (
            <RichText
              as="div"
              className="eyebrow mb-8 text-brand-blue/70"
              value={eyebrow}
            />
          )}
          <div aria-hidden className="mx-auto mb-6 h-px w-12 bg-brand-blue/30" />
          <RichText
            as="p"
            className="font-serif italic text-[22px] sm:text-[26px] leading-[1.5] text-brand-ink/85"
            value={body}
          />
          {attribution && (
            <RichText
              as="div"
              className="mt-8 text-[13px] tracking-[0.18em] uppercase text-brand-ink/55"
              value={attribution}
            />
          )}
        </motion.div>
      </div>
    </section>
  );
}
